import { render, staticRenderFns } from "./shopping-cart-continue-shopping.vue?vue&type=template&id=96f82836&scoped=true&"
import script from "./shopping-cart-continue-shopping.vue?vue&type=script&lang=ts&"
export * from "./shopping-cart-continue-shopping.vue?vue&type=script&lang=ts&"
import style0 from "./shopping-cart-continue-shopping.vue?vue&type=style&index=0&id=96f82836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f82836",
  null
  
)

export default component.exports